export class PhoneContact {
  id: number;
  countryCode?: {};
  phoneNo?: number;
  type?: {
    id: number
  };
}
